var map = {
	"./assets/close-icon.png": 31523,
	"./assets/social/apple.png": 46679,
	"./assets/social/email.png": 81370,
	"./assets/social/facebook.png": 52692,
	"./assets/social/google.png": 1279,
	"./assets/social/twitter.png": 71532,
	"./assets/wallets/avalanche.png": 33296,
	"./assets/wallets/bsc.png": 7416,
	"./assets/wallets/okex.png": 29231,
	"./assets/wallets/terra.png": 56161,
	"./assets/wallets/wallet-connect.png": 31686,
	"./singlesignon": 69562,
	"./singlesignon.tsx": 69562,
	"components/singlesignon/assets/close-icon.png": 31523,
	"components/singlesignon/assets/social/apple.png": 46679,
	"components/singlesignon/assets/social/email.png": 81370,
	"components/singlesignon/assets/social/facebook.png": 52692,
	"components/singlesignon/assets/social/google.png": 1279,
	"components/singlesignon/assets/social/twitter.png": 71532,
	"components/singlesignon/assets/wallets/avalanche.png": 33296,
	"components/singlesignon/assets/wallets/bsc.png": 7416,
	"components/singlesignon/assets/wallets/okex.png": 29231,
	"components/singlesignon/assets/wallets/terra.png": 56161,
	"components/singlesignon/assets/wallets/wallet-connect.png": 31686,
	"components/singlesignon/singlesignon": 69562,
	"components/singlesignon/singlesignon.tsx": 69562
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13418;